import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { IWorkOrderReportCreated } from "../../../../common/data/dtos/work-order-report-created";
import WorkOrderReportStatusEnum from "../../../../common/data/enums/enumWorkOrderReportStatus";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from "../../../../components/bootstrap/Card";
import Spinner from "../../../../components/bootstrap/Spinner";
import { MoreActions } from "../../../../components/extras/MoreActions";
import { showWarning } from "../../../../components/extras/Notifications";
import PaginationButtons, { dataPagination, PER_COUNT } from "../../../../components/PaginationButtons";
import workOrderReportService from "../../../../services/work-order-report-service";
import LoadingPage from "../../loading/LoadingPage";

export const CommonWorkOrderReportList = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(PER_COUNT['10']);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [workOrdersReport, setWorkOrdersReport] = useState<IWorkOrderReportCreated[]>([]);

    useEffect(() => {
        fetchReports();
    }, []);

    const fetchReports = async () => {
        setIsLoading(true);

        const response = await workOrderReportService.getReports();
        setIsLoading(false);

        if (response.error) {
            showWarning(response.error);
            return;
        }

        setWorkOrdersReport(response.workOrderReportsCreated || []);
    };


    const handleViewClick = async (workOrderReport: IWorkOrderReportCreated) => {
        if (!workOrderReport.url) {
            showWarning('Falha ao exibir arquivo')
            return;
        }

        window.open(workOrderReport.url, '_blank', 'noopener,noreferrer');
    }

    const handleRefreshClick = async () => {
        fetchReports();
    }

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <>
            <Card style={{ minHeight: 600 }}>
                <CardHeader borderSize={1}>
                    <CardLabel icon='InsertDriveFile' iconColor='primary'>
                        <CardTitle tag='div' className='h5'>
                            Ordens de Serviço
                        </CardTitle>
                    </CardLabel>
                    <CardActions>

                        <Button color="light" icon="Refresh" onClick={() => handleRefreshClick()} isDisable={isLoading}>
                            {isLoading && <Spinner isSmall inButton isGrow />}
                            Atualizar
                        </Button>

                    </CardActions>
                </CardHeader>
                <CardBody className='table-responsive'>
                    <table className='table table-modern table-hover'>
                        <thead>
                            <tr>
                                <th>Data Solicitação</th>
                                <th>Solicitante</th>
                                <th>Responsável</th>
                                <th>Tipo</th>
                                <th>Cliente</th>
                                <th>Situação</th>
                                <td aria-labelledby='Actions' />
                            </tr>
                        </thead>
                        <tbody>
                            {dataPagination(workOrdersReport, currentPage, perPage).map((item: IWorkOrderReportCreated) => (
                                <tr key={item.id}>

                                    <td>{item.completedAt ? dayjs(item.completedAt).format('DD/MM/YYYY hh:MM') : '-'}</td>
                                    <td>{item?.requestedByEmail ?? '-'}</td>
                                    <td>{item?.createdByName ?? '-'}</td>
                                    <td>{item?.serviceType ?? '-'}</td>
                                    <td>{item?.customerName ?? '-'}</td>
                                    <td>{item?.reportStatusDescription ?? '-'}</td>

                                    {
                                        item.reportStatus === WorkOrderReportStatusEnum.completed && (
                                            <MoreActions
                                                id={item.id}
                                                showEdit={false}
                                                showDelete={false}
                                                customActions={[
                                                    {
                                                        label: 'Visualizar',
                                                        icon: 'RemoveRedEye',
                                                        onClickAction: () => handleViewClick(item),
                                                    }
                                                ]}
                                            />
                                        )
                                    }

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </CardBody>
                {<PaginationButtons data={workOrdersReport} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />}
            </Card>
        </>
    );
}